export default __webpack_public_path__ + "static/media/line4_2.bf5331e2.svg";